import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import {
  BusinessEntity,
  BusinessEntityUser
} from '../../models/business-entity';
import { BusinessEntityControllerService } from '../../services/business-entity-controller.service';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'app-manage-business-entity',
  templateUrl: './manage-business-entity.component.html'
})
export class ManageBusinessEntityComponent implements OnInit {
  accessDenied: boolean = false;
  bsModalRef?: BsModalRef;
  nbRoots: number = 1;
  businessEntity!: BusinessEntity;
  emailToAdd: string = '';
  emailFieldInvalid: boolean = false;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly businessEntityController: BusinessEntityControllerService,
    private readonly modalService: BsModalService
  ) {}

  ngOnInit(): void {
    this.businessEntityController
      .getBusinessEntity(this.route.snapshot.params['id'], { skip_files: true })
      .subscribe((result: BusinessEntity) => {
        this.businessEntity = result;
      });
  }

  removeUser(user: BusinessEntityUser) {
    const initialState: ModalOptions = {
      initialState: {
        title: 'confirm-modal-confirmation',
        isConfirm: true
      },
      class: 'danger confirmation-modal modal-dialog-centered'
    };
    this.bsModalRef = this.modalService.show(ModalComponent, initialState);
    this.bsModalRef.content.resolveModal.subscribe((value: string) => {
      if (value !== 'confirm') return;
      if (this.businessEntity) {
        this.businessEntity.users = this.businessEntity?.users.filter(
          (u) => u !== user
        );
        this._updateBusinessEntity();
      }
    });
  }

  onAccessChange(user: BusinessEntityUser) {
    if (user.has_root) {
      user.has_create = true;
      user.has_write = true;
      user.has_read = true;
    }
    if (user.has_create) {
      user.has_write = true;
      user.has_read = true;
    }
    if (user.has_write) {
      user.has_read = true;
    }
    this._updateBusinessEntity();
  }

  canAdd() {
    if (!this.emailToAdd) return false;
    if (!this.validEmail(this.emailToAdd)) return false;
    return this.businessEntity?.users.every((user) => {
      return user.email !== this.emailToAdd;
    });
  }

  addUser() {
    if (!this.canAdd()) return;
    let newUser = new BusinessEntityUser();
    newUser.email = this.emailToAdd;
    newUser.has_read = true;
    newUser.has_write = false;
    newUser.has_create = false;
    newUser.has_root = false;
    this.businessEntity?.users.push(newUser);
    this._updateBusinessEntity();
    this.emailToAdd = '';
  }

  validEmail(email: string) {
    const result = email !== '' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!result) {
      this.emailFieldInvalid = true;
    }
    return result;
  }

  clearEmailFieldValidation() {
    this.emailFieldInvalid = false;
  }

  private _updateBusinessEntity() {
    if (!this.businessEntity) return;
    this.businessEntityController
      .updateBusinessEntity(this.businessEntity, { withUsers: true })
      .subscribe();
  }

  confirmNameChangeModal(template: TemplateRef<any>) {
    const initialState: ModalOptions = {
      class: 'danger confirmation-modal modal-dialog-centered'
    };
    this.bsModalRef = this.modalService.show(template, initialState);
  }

  confirmNameChange() {
    this.businessEntityController
      .updateBusinessEntity(this.businessEntity as BusinessEntity)
      .subscribe({
        next: () => {
          if (this.businessEntity) {
            this.businessEntity.originalName = this.businessEntity.name;
            this.businessEntity.nameEdition = false;
          }
        },
        error: () => {
          // generic error handling for ajax calls...
        }
      });
  }
}
